import { Component, DestroyRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { VerticalNavigation } from '../vertical-navigation/vertical-navigation';
import { CommonModule } from '@angular/common';
import { MenuImp } from '../../core/models/menu-imp';
import { AppService } from '../../core/services/app-service';
import { Constante } from '../../constante';
import { Header } from '../shared/header/header';
import { Menu } from '../../core/models/interface/menu';
import { FuseNavigationItem } from '../../core/models/interface/navigation.types';
import { NavigationItem } from '../../core/models/navigation-item';
import { MenuAs, UsuarioAS } from '../../core/models/interface/auth';
import { AppUtil } from '../../core/utility/app-util';
import { AuthUtility } from '../../core/utility/auth-utility';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-classic-layout',
    imports: [
        CommonModule,
        RouterOutlet,
        MatIconModule,
        MatButtonModule,
        VerticalNavigation,
        Header
    ],
    templateUrl: './classic-layout.html',
    styleUrl: './classic-layout.scss'
})
export class ClassicLayout {
    _const = Constante;
    openMenuNavigation: boolean = true;
    version = environment.VERSION;
    year = new Date().getFullYear();

    menu: Menu[] = [];
    navigation: FuseNavigationItem[] = [];

    dataUser: UsuarioAS | null = null

    constructor(
        public appService: AppService,
        private destroyRef: DestroyRef,
        private toastService: ToastrService
    ) {
        this.construirMenu()
    }

    ngOnInit() {
    }

    construirMenu() {
        const _menuHome = new NavigationItem();
        _menuHome.id = "0";
        _menuHome.type = "basic";
        _menuHome.title = "Inicio";
        _menuHome.link = "/inicio";
        _menuHome.icon = 'heroicons_outline:home';

        const _mantenimientoInstitucion = new NavigationItem();
        _mantenimientoInstitucion.id = "1.5";
        _mantenimientoInstitucion.type = "basic";
        _mantenimientoInstitucion.title = "Instituciones";
        _mantenimientoInstitucion.link = "/mantenimiento-instituciones";
        _mantenimientoInstitucion.icon = 'heroicons_outline:academic-cap';

        // Menú de Reportes
        const _reporteHoy = new NavigationItem();
        _reporteHoy.id = "2.1";
        _reporteHoy.type = "basic";
        _reporteHoy.title = "Reporte Hoy";
        _reporteHoy.link = "/asistencia-reportes/hoy";
        _reporteHoy.icon = 'heroicons_outline:calendar-days';

        const _reporteBimestral = new NavigationItem();
        _reporteBimestral.id = "2.3";
        _reporteBimestral.type = "basic";
        _reporteBimestral.title = "Reporte Bimestral";
        _reporteBimestral.link = "/asistencia-reportes/bimestral";
        _reporteBimestral.icon = 'heroicons_outline:table-cells';

        const _reporteMensual = new NavigationItem();
        _reporteMensual.id = "2.4";
        _reporteMensual.type = "basic";
        _reporteMensual.title = "Reporte Mensual";
        _reporteMensual.link = "/asistencia-reportes/mensual";
        _reporteMensual.icon = 'heroicons_outline:calendar';

        const _reportes = new NavigationItem();
        _reportes.id = "2";
        _reportes.type = "collapsable";
        _reportes.title = "Reportes";
        _reportes.icon = 'heroicons_outline:chart-pie';
        _reportes.children = [_reporteHoy, _reporteBimestral, _reporteMensual];

        // Menú de Estudiantes
        const _listaEstudiantes = new NavigationItem();
        _listaEstudiantes.id = "3.1";
        _listaEstudiantes.type = "basic";
        _listaEstudiantes.title = "Lista por Sección";
        _listaEstudiantes.link = "/estudiantes/listar-por-seccion";
        _listaEstudiantes.icon = 'heroicons_outline:user-group';

        const _buscarEstudiantes = new NavigationItem();
        _buscarEstudiantes.id = "3.2";
        _buscarEstudiantes.type = "basic";
        _buscarEstudiantes.title = "Panel del Estudiante";
        _buscarEstudiantes.link = "/estudiantes/buscar";
        _buscarEstudiantes.icon = 'heroicons_outline:user';

        const _misEstudiantes = new NavigationItem();
        _misEstudiantes.id = "3.3";
        _misEstudiantes.type = "basic";
        _misEstudiantes.title = "Mis Estudiantes";
        _misEstudiantes.link = "/estudiantes/mis-estudiantes";
        _misEstudiantes.icon = 'heroicons_outline:academic-cap';

        const _edicionDatos = new NavigationItem();
        _edicionDatos.id = "11";
        _edicionDatos.type = "basic";
        _edicionDatos.title = "Edición de datos";
        _edicionDatos.link = "/edicion-datos";
        _edicionDatos.icon = 'heroicons_outline:pencil-square';

        const _estudiantes = new NavigationItem();
        _estudiantes.id = "3";
        _estudiantes.type = "collapsable";
        _estudiantes.title = "Estudiantes";
        _estudiantes.icon = 'heroicons_outline:identification';

        // Menú de Registro de Asistencia
        const _registroAsistencia = new NavigationItem();
        _registroAsistencia.id = "4";
        _registroAsistencia.type = "basic";
        _registroAsistencia.title = "Registro de Asistencia";
        _registroAsistencia.link = "/registro-asistencia";
        _registroAsistencia.icon = 'heroicons_outline:finger-print';

        // Menú de Calendario
        const _calendario = new NavigationItem();
        _calendario.id = "5";
        _calendario.type = "basic";
        _calendario.title = "Calendario Académico";
        _calendario.link = "/calendario";
        _calendario.icon = 'heroicons_outline:calendar';

        const _miInstitucion = new NavigationItem();
        _miInstitucion.id = "6.0";
        _miInstitucion.type = "basic";
        _miInstitucion.title = "Mi Institución";
        _miInstitucion.link = "/mi-institucion";
        _miInstitucion.icon = 'heroicons_outline:building-library';

        const _actualizarDatos = new NavigationItem();
        _actualizarDatos.id = "6.1";
        _actualizarDatos.type = "basic";
        _actualizarDatos.title = "Actualizar Datos";
        _actualizarDatos.link = "/administracion-ie/actualizar-datos";
        _actualizarDatos.icon = 'heroicons_outline:pencil-square';

        const _configAnio = new NavigationItem();
        _configAnio.id = "6.2";
        _configAnio.type = "basic";
        _configAnio.title = "Conf. Año Escolar";
        _configAnio.link = "/administracion-ie/configuracion-anio";
        _configAnio.icon = 'heroicons_outline:cog-6-tooth';

        const _modificarDatosCriticos = new NavigationItem();
        _modificarDatosCriticos.id = "6.3";
        _modificarDatosCriticos.type = "basic";
        _modificarDatosCriticos.title = "Modificar Datos Críticos";
        _modificarDatosCriticos.link = "/administracion-ie/modificar-datos-criticos";
        _modificarDatosCriticos.icon = 'heroicons_outline:shield-exclamation';

        const _administracionIE = new NavigationItem();
        _administracionIE.id = "6";
        _administracionIE.type = "collapsable";
        _administracionIE.title = "Administración I.E.";
        _administracionIE.icon = 'heroicons_outline:building-office-2';
        _administracionIE.children = [_actualizarDatos, _configAnio];

        // Menú de Práctica Pedagógica
        const _ppDashboard = new NavigationItem();
        _ppDashboard.id = "9.1";
        _ppDashboard.type = "basic";
        _ppDashboard.title = "Dashboard";
        _ppDashboard.link = "/practica-pedagogica/dashboard";
        _ppDashboard.icon = 'heroicons_outline:presentation-chart-bar';

        const _ppPlanificacion = new NavigationItem();
        _ppPlanificacion.id = "9.2";
        _ppPlanificacion.type = "basic";
        _ppPlanificacion.title = "Planificación";
        _ppPlanificacion.link = "/practica-pedagogica/planificacion";
        _ppPlanificacion.icon = 'heroicons_outline:document-text';

        const _ppEjecucion = new NavigationItem();
        _ppEjecucion.id = "9.3";
        _ppEjecucion.type = "basic";
        _ppEjecucion.title = "Ejecución";
        _ppEjecucion.link = "/practica-pedagogica/ejecucion";
        _ppEjecucion.icon = 'heroicons_outline:clipboard-document-check';

        const _ppDocente = new NavigationItem();
        _ppDocente.id = "9.4";
        _ppDocente.type = "basic";
        _ppDocente.title = "Mis Monitoreos";
        _ppDocente.link = "/practica-pedagogica/mis-monitoreos";
        _ppDocente.icon = 'heroicons_outline:clipboard-document-list';

        const _practicaPedagogica = new NavigationItem();
        _practicaPedagogica.id = "9";
        _practicaPedagogica.type = "collapsable";
        _practicaPedagogica.title = "Práctica Pedagógica";
        _practicaPedagogica.icon = 'heroicons_outline:academic-cap';
        _practicaPedagogica.children = [];

        // Menú de Notificaciones
        const _recibidas = new NavigationItem();
        _recibidas.id = "7.1";
        _recibidas.type = "basic";
        _recibidas.title = "Recibidas";
        _recibidas.link = "/notificaciones/recibidas";
        _recibidas.icon = 'heroicons_outline:inbox';

        const _enviadas = new NavigationItem();
        _enviadas.id = "7.2";
        _enviadas.type = "basic";
        _enviadas.title = "Enviadas";
        _enviadas.link = "/notificaciones/enviadas";
        _enviadas.icon = 'heroicons_outline:paper-airplane';

        const _notificaciones = new NavigationItem();
        _notificaciones.id = "7";
        _notificaciones.type = "collapsable";
        _notificaciones.title = "Notificaciones";
        _notificaciones.icon = 'heroicons_outline:bell';
        _notificaciones.children = [_recibidas, _enviadas];

        const _groupDashboard = new NavigationItem();
        _groupDashboard.id = "14";
        _groupDashboard.type = "group";
        _groupDashboard.title = "Módulos Principales";

        const _mantenimientoUsuario = new NavigationItem();
        _mantenimientoUsuario.id = "1.6";
        _mantenimientoUsuario.type = "basic";
        _mantenimientoUsuario.title = "Mantenimiento Usuarios";
        _mantenimientoUsuario.link = "/mantenimiento-usuarios";
        _mantenimientoUsuario.icon = 'heroicons_outline:users';

        const _mantenimientoUsuarioSuper = new NavigationItem();
        _mantenimientoUsuarioSuper.id = "1.7";
        _mantenimientoUsuarioSuper.type = "basic";
        _mantenimientoUsuarioSuper.title = "Mantenimiento Usuarios (S)";
        _mantenimientoUsuarioSuper.link = "/mantenimiento-usuarios-super";
        _mantenimientoUsuarioSuper.icon = 'heroicons_outline:shield-check';

        // Menú de Personal (Staff)
        const _gestionPersonal = new NavigationItem();
        _gestionPersonal.id = "8.1";
        _gestionPersonal.type = "basic";
        _gestionPersonal.title = "Personal";
        _gestionPersonal.link = "/staff";
        _gestionPersonal.icon = 'heroicons_outline:user-circle';

        const _asignacionAulas = new NavigationItem();
        _asignacionAulas.id = "8.2";
        _asignacionAulas.type = "basic";
        _asignacionAulas.title = "Asignación de Aulas";
        _asignacionAulas.link = "/staff/staff-por-seccion";
        _asignacionAulas.icon = 'heroicons_outline:user-group';

        const _personalInstitucion = new NavigationItem();
        _personalInstitucion.id = "8";
        _personalInstitucion.type = "collapsable";
        _personalInstitucion.title = "Gestión de Personal"; // User requested this name in a previous conversation
        _personalInstitucion.icon = 'heroicons_outline:users';

        // Menú de Asistencia de Hijos (para padres)
        const _asistenciaHijos = new NavigationItem();
        _asistenciaHijos.id = "10";
        _asistenciaHijos.type = "basic";
        _asistenciaHijos.title = "Asistencia";
        _asistenciaHijos.link = "/asistencia-hijos";
        _asistenciaHijos.icon = 'heroicons_outline:clipboard-document-check';

        const user = AuthUtility.getValueUserAS();
        // If it's a BOT, we completely override and show almost nothing
        if (user && user.cPerfil?.toUpperCase().includes('BOT')) {
            _groupDashboard.children = [_registroAsistencia];
        } else {
            // Resolve institutional visibility by role
            const role = user?.cPerfil?.toUpperCase() || '';
            const isAdminOrDir = role.includes('SUPER USER') || role.includes('ADMINISTRADOR') || role.includes('DIRECTIVO') || role.includes('DIRECTOR');


            // General setup for non-bots
            const coreMenu = [
                _menuHome,
                _miInstitucion
            ];

            if (isAdminOrDir) {
                if (role.includes('ADMINISTRADOR')) {
                    _administracionIE.children = [_actualizarDatos, _configAnio, _modificarDatosCriticos];
                } else {
                    _administracionIE.children = [_actualizarDatos, _configAnio];
                }
                coreMenu.push(_administracionIE);
            }

            if (!environment.production && (role.includes('DIRECTIVO') || role.includes('DOCENTE'))) {
                if (role.includes('DOCENTE')) {
                    _practicaPedagogica.children = [_ppDocente];
                } else {
                    _practicaPedagogica.children = [_ppDashboard, _ppPlanificacion, _ppEjecucion];
                }
                coreMenu.push(_practicaPedagogica);
            }

            coreMenu.push(_estudiantes);


            if (!role.includes('SUPER USER')) {
                coreMenu.push(_notificaciones);
                if (role.includes('PADRE') || role.includes('ESTUDIANTE')) {
                    _notificaciones.children = [_recibidas];
                }
            }

            // Reportes: auxiliar, directivo y administrador (director = directivo)
            if (role.includes('ADMINISTRADOR') || role.includes('DIRECTIVO') || role.includes('DIRECTOR') || role.includes('AUXILIAR')) {
                coreMenu.push(_reportes);
            } else if (role.includes('DOCENTE')) {
                // Docente solo ve Reporte Hoy, Reporte Bimestral y Reporte Mensual
                _reportes.children = [_reporteHoy, _reporteBimestral, _reporteMensual];
                coreMenu.push(_reportes);
            }

            if (!role.includes('SUPER USER')) {
                // Personal de la Institución
                if (role.includes('DOCENTE') || role.includes('PADRE') || role.includes('ESTUDIANTE')) {
                    _personalInstitucion.title = "Personal de la I.E.";
                }
                const personalChildren: FuseNavigationItem[] = [];
                personalChildren.push(_gestionPersonal);
                if (isAdminOrDir || role.includes('AUXILIAR')) {
                    personalChildren.push(_asignacionAulas);
                }
                _personalInstitucion.children = personalChildren;
                coreMenu.push(_personalInstitucion);

                // Calendario
                coreMenu.push(_calendario);

                // Asistencia de Hijos (para padres)
                if (role.includes('PADRE') || role.includes('ESTUDIANTE')) {
                    if (role.includes('ESTUDIANTE')) {
                        _asistenciaHijos.title = "Mis Asistencias";
                    }
                    coreMenu.push(_asistenciaHijos);
                }
            }

            if (role.includes('ADMINISTRADOR') || role.includes('AUXILIAR')) {
                // Posicionar registro de asistencia antes de estudiantes
                coreMenu.splice(2 + (isAdminOrDir ? 1 : 0), 0, _registroAsistencia);
            }

            // Lógica interna para Sub-módulos de Estudiantes
            if (role.includes('DOCENTE')) {
                // Docentes solo ven 'Mis Estudiantes'
                _estudiantes.children = [_misEstudiantes];
            } else if (isAdminOrDir) {
                // Admin y Directivo ven lista y panel (no "mis estudiantes")
                _estudiantes.children = [_listaEstudiantes, _buscarEstudiantes];
            } else if (role.includes('AUXILIAR')) {
                // Auxiliar tiene acceso a todo el módulo
                _estudiantes.children = [_listaEstudiantes, _buscarEstudiantes, _misEstudiantes];
            } else {
                // Si llegara a colarse otra cosa (Padre, Estudiante, etc), quitamos estudiantes
                const idx = coreMenu.indexOf(_estudiantes);
                if (idx > -1) coreMenu.splice(idx, 1);
            }

            // Mantenimiento y root rules
            if (role.includes('SUPER USER')) {
                coreMenu.push(_mantenimientoInstitucion);
                coreMenu.push(_mantenimientoUsuarioSuper);
            }
            if (role.includes('ADMINISTRADOR')) {
                coreMenu.push(_mantenimientoUsuario);
            }
            if (role.includes('ADMINISTRADOR') || role.includes('SUPER USER')) {
                coreMenu.push(_edicionDatos);
            }

            _groupDashboard.children = coreMenu;
        }

        this.navigation = [_groupDashboard];
    }

    formarMenus(data: MenuAs[]) {
        const _menuHome = new NavigationItem();
        _menuHome.id = "0";
        _menuHome.type = "basic";
        _menuHome.title = "Inicio";
        _menuHome.link = "/inicio";
        _menuHome.icon = 'heroicons_outline:home';

        const menus: NavigationItem[] = data.map(item => {
            const navItem = new NavigationItem();
            navItem.id = item.idMenu.toString();
            navItem.type = item.idMenuPadre == 0 ? 'basic' : 'group';
            navItem.title = item.cMenu;
            navItem.link = item.cUrl;
            navItem.icon = item.cIcon;
            return navItem;
        });
        const _groupDashboard = new NavigationItem();
        _groupDashboard.id = "14";
        _groupDashboard.type = "group";
        _groupDashboard.title = "Modulo Dashboard";

        _groupDashboard.children = [
            _menuHome
        ];

        _groupDashboard.children = _groupDashboard.children.concat(menus)

        this.navigation = [_groupDashboard];
    }
}
